






































import { Component, Prop, Vue } from "vue-property-decorator";
import { Personal as PersonalInfo } from "@/types";
import { Api } from "@/api";

@Component
export default class Personal extends Vue {
  @Prop() personal!: PersonalInfo;
  currentLocation = "";

  mounted() {
    this.fetchCountry();
  }

  fetchCountry() {
    Api.getLocation()
      .then(c => {
        this.currentLocation = c;
      })
      .catch(error => {
        this.currentLocation = error;
      });
  }
}
